/* prettier-ignore */
import { toUri } from './utils';
import getDeviceId from './deviceId';
import api from '~/services';
// import { reportToHive } from '~/assets/js/player/report';

const WebSocket = process.client ? window.WebSocket || window.MozWebSocket : {};
const NUXT_ENV_MODE = process.env.NUXT_ENV_MODE;
const isProd = NUXT_ENV_MODE === 'prod';

let id = 0;

const EVENT = {
  LOGIN: 512535,
  END_ROOM: 0,
  ENTER_ROOM_RES: 1560,
  NORMAL_TEXT: 2584,
  ROOM_OWNER_LEAVE_TEXT: 2,
  ROOM_OWNER_BACK_TEXT: 3,
  SHARE_LIVING_TEXT: 4,
  NUMS: 10264,
  PC_ASSISTANT: 10520,
  NO_PC_ASSISTANT: 7,
  NORMAL_GIFT_TEXT: 8,
  LIGHT_MY_HEART_TEXT: 9,
  FOLLOW_OWNER_TEXT: 10,
  ANNOUNCE_TEXT: 11,
  LEAVE_RES: 2072
};

const CHAT_EVENT = {
  NORMAL_TEXT: 1,
  DAMMARKU_TEXT: 2,
  LIGHT_MY_HEART_TEXT: 3,
  ROOM_OWNER_LEAVE_TEXT: 4,
  ROOM_OWNER_BACK_TEXT: 5,
  NORMAL_GIFT_TEXT: 6,
  FOLLOW_OWNER_TEXT: 8,
  SHARE_LIVING_TEXT: 10,
  ANNOUNCE_TEXT: 11
};

const urlMap = {
  dev: 'wss://wss.bigolive.tv/bigo/web',
  test: 'wss://test-ws-json2yy.imolive.tv/bigo_as/web',
  gray: 'wss://wss.bigolive.tv/bigo/web',
  prod: 'wss://wss.bigolive.tv/bigo/web'
};

if (process.client) {
  if (window.location.origin.includes('bigoapp.tv')) {
    urlMap[NUXT_ENV_MODE] = 'wss://wss.bigoapp.tv/bigo_as/web';
  }
}

export default class ChatWs {
  constructor(liveInfo, $log) {
    this.id = id++;
    this.liveInfo = liveInfo;
    this.ws = null;
    this.url = urlMap[NUXT_ENV_MODE];
    this.observerObj = {};
    this.retryTimes = 0;
    this.bigoId = null;
    this.wsConfig = {};
    this.timer = null;
    this.$log = $log;
    this.password = '';
  }

  static EVENT = EVENT;
  static CHAT_EVENT = CHAT_EVENT;

  static isInEvent(event) {
    return Object.values(EVENT).includes(event);
  }

  static log(msg, data) {
    if (!data) {
      console.info(`wss-receive-log: ${msg}`);
    } else {
      console.info(`wss-receive-log: ${msg}`, data);
    }
  }

  async init(options = {}) {
    console.log('init wss');
    await this.getWebSocketLink();
    this.password = options.password;
    this.connect();
  }

  async getWebSocketLink() {
    const deviceId = await getDeviceId();
    const { code, data } = await api.getWebSocketLink({ deviceId });
    if (code !== 0) {
      this.$log &&
        this.$log.error('request error', { api: 'getWebSocketLink' });
      return;
    }
    this.wsConfig = data;
    return this.url;
  }

  reconnect() {
    if (this.retryTimes >= 3) return;
    this.connect(this.url);
  }

  connect() {
    const createNewWebSocket = () => {
      const ws = new WebSocket(this.url);
      // ws.binaryType = 'arraybuffer';
      ws.onopen = () => {
        this.pub('WS_INIT_FINISH');
        this.doLogin(this.wsConfig);
        // 心跳
        this.timer = setInterval(() => {
          this.doPing();
        }, 10000);
      };
      ws.onmessage = (e) => {
        const JSONIndex = e.data.indexOf('{');
        const msgData = JSON.parse(e.data.slice(JSONIndex));
        const eid = +e.data.slice(0, JSONIndex).trim();
        this.handleMessage({
          eid,
          data: msgData
        });
        this.pub(eid, msgData, ws);
      };
      ws.onclose = (e) => {
        clearInterval(this.timer);
        ChatWs.log('close', e);
      };
      ws.onerror = (e) => {
        ChatWs.log('error', e);

        this.retryTimes += 1;
        this.reconnect();
        this.$log &&
          this.$log.error('wss error', {
            msg: `websocket连接出错$${JSON.stringify(e)}`
          });
      };

      return ws;
    };

    window.onbeforeunload = () => {
      // this.isIECloseSocket = false;
      this.destroy();
    };

    this.ws = createNewWebSocket();
  }

  doLogin(data) {
    const obj = {
      uid: data.userId,
      cookie: data.uidToken.replace('###VER2', ''),
      secret: '0',
      userName: '0',
      deviceId: data.deviceId,
      userFlag: '0',
      status: '0',
      password: '0',
      sdkVersion: '0',
      displayType: '0',
      pbVersion: '0',
      // lang: this.$locale,
      lang: 'cn',
      loginLevel: '0',
      clientVersionCode: '0',
      clientType: isProd ? '8' : '7', // 灰度wss传7，线上环境要传 8
      clientOsVer: '0',
      netConf: {
        clientIp: data.clientIp || '0',
        proxySwitch: '0',
        proxyTimestamp: '0',
        mcc: '0',
        mnc: '0',
        // countryCode: this.info.country
        countryCode: 'CN'
      }
    };
    const params = `${toUri('2001|23')}${JSON.stringify(obj)}`;

    this.ws && this.ws.send(params);
  }

  doPing() {
    if (this.ws && this.ws.readyState === 3) {
      clearInterval(this.timer);
      return;
    }
    const params = `791${JSON.stringify({
      status: '0',
      seqid: `${new Date().getTime()}`,
      flag: '0',
      roomId: '0',
      ownerStatus: '0',
      micUid: '0'
    })}`;
    this.ws && this.ws.send(params);
  }

  enterRoom(secretKey = '0') {
    const params = `${toUri('5|24')}${JSON.stringify({
      secretKey,
      seqId: `${new Date().getTime()}`,
      roomId: this.liveInfo.roomId,
      reserver: '1',
      clientVersion: '0',
      clientType: '7',
      version: '15',
      deviceid: this.wsConfig.deviceId, // ?? 大小写
      other: []
    })}`;
    this.ws && this.ws.send(params);
  }

  pullChatRoomUser() {
    // 获取直播间观众数
    const params = `${toUri('42|24')}${JSON.stringify({
      uid: `${this.liveInfo.uid}`,
      seqId: `${new Date().getTime()}`,
      roomid: this.liveInfo.roomId,
      contribution: '0',
      enterTimestamp: '0',
      number: '0',
      ident: '0',
      userGrade: '0',
      version: '0',
      lastUserBeanGrade: '0',
      lastUserId: '0',
      others: []
    })}`;
    this.ws && this.ws.send(params);
  }

  handleMessage(msg) {
    switch (msg.eid) {
      case EVENT.LOGIN:
        if (msg.data.res === '200') {
          ChatWs.log('login success');
          this.liveInfo.clientIp = msg.data.clientIp;
          this.enterRoom(this.password);
        } else {
          ChatWs.log('登录失败！');
          this.retryTimes += 1;
          this.reconnect();
        }
        break;
      case EVENT.ENTER_ROOM_RES: {
        if (msg?.data?.resCode === '200') {
          ChatWs.log('enter room success');
          this.pullChatRoomUser();
        }
        break;
      }
      case EVENT.LEAVE_RES:
        // 主播下播后发送7|24的响应
        ChatWs.log('收到7|24的响应');
        this.destroy();
    }
  }

  send(id, msg) {
    const data = `${toUri(id)}${JSON.stringify({ ...msg })}`;
    if (this.ws) {
      this.ws.send(data);
      console.log('wss-send-log: 发送wss消息！', id, data);
    }
  }

  sub(event, fn) {
    if (event in this.observerObj) {
      this.observerObj[event].push(fn);
    } else {
      this.observerObj[event] = [fn];
    }
  }

  pub(event, msg, ws) {
    if (event in this.observerObj) {
      const observers = this.observerObj[event];
      observers.forEach((fn) => {
        fn(msg, ws);
      });
    }
  }

  unsubAll() {
    this.observerObj = {};
  }

  destroy() {
    if (!this.ws) return;
    try {
      this.unsubAll();
      this.ws.send('close');
      this.ws.close();
      this.retryTimes = 0;
      this.ws = null;
      clearInterval(this.timer);
    } catch (err) {
      console.log('ws销毁失败', err);
    }
  }
}
